/**
 * Created by rathompson on 12/12/22
 * File: IdentityService
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import axios from 'axios'
import { getVarValue } from '../../common/utils/Sparky'
import { getTsgToken, getFrameworkServiceUrl } from '@sparky/framework'
import { FF_USE_LOCAL_IAM_SERVICE } from '../../common/utils/FeatureFlags'

const includeClaims = getVarValue(FF_USE_LOCAL_IAM_SERVICE, false)

const IDENTITY_URL_KEY = 'identity_base_url'
const IDENTITY_SVC_URL_KEY = 'identity_service'

const IdentityAPI = axios.create({
  baseURL: getFrameworkServiceUrl(IDENTITY_SVC_URL_KEY) || getVarValue(IDENTITY_URL_KEY),
  timeout: 300 * 1000,
})

IdentityAPI.interceptors.request.use(async config => {
  const token = await getTsgToken(config?.tsg_id)
  config.headers = { ...config.headers, 'Authorization': `Bearer ${token}` }
  if (includeClaims) {
    config.headers.claims = token.split('.')[1]
  }
  if (config?.contentType === 'xml') {
    config.headers = { ...config.headers, 'Content-Type': 'text/xml' }
  }
  return config
}, error => {
  return Promise.reject(error)
})

IdentityAPI.interceptors.response.use((response) => response, (error) => {
  const e = new Error(error.response?.data?.message || error.response?.data?.msg || error.message)
  e.response = error.response
  throw e
})

const IdentityService = {
  federations: {
    list: (tsg_id) => IdentityAPI.get('/federations', { tsg_id }),
    getMetadata: (tsg_id, domain, metadataUrl, contentType) => IdentityAPI.get(`/federations/${domain}/idp_metadata?url=${metadataUrl}`, { tsg_id, contentType }),
    get: (tsg_id, domain) => IdentityAPI.get(`/federations/${domain}/sp_metadata`, { tsg_id }),
    createOwner: (tsg_id, domain, params) => IdentityAPI.post(`/federations/${domain}/owners`, params, { tsg_id }),
    createIDP: (tsg_id, domain, params) => IdentityAPI.post(`/federations/${domain}/idps`, params, { tsg_id }),
    delete: (tsg_id, domain) => IdentityAPI.delete(`/federations/${domain}`, { tsg_id }),
    deleteOwner: (tsg_id, domain, email) => IdentityAPI.delete(`/federations/${domain}/owners/${email}`, { tsg_id }),
    updateIDP: (tsg_id, domain, idpId, params) => IdentityAPI.put(`/federations/${domain}/idps/${idpId}`, params, { tsg_id }),
    federationMapping: {
      list: (tsg_id, domain) => IdentityAPI.get(`/federations/${domain}/federation_mappings`, { tsg_id })
    },
    auditLogs: (tsg_id, domain) => IdentityAPI.get(`/federations/${domain}/logs`, { tsg_id })
  }
}

export default IdentityService

